import { tabAccessControl } from "../../../_helpers/access-control";

let MaintenanceOrderTabs = [
  {
    text: "All",
    path: `/maintenance-order`,
    applicationFeatureCode: "MaintenanceOrder",
  },
  {
    text: "Draft",
    path: '/maintenance-order-draft',
    applicationFeatureCode: "MaintenanceOrder", // TODO : Change Accordingly
  },
  {
    text: "Open",
    path: '/maintenance-order-open',
    applicationFeatureCode: "MaintenanceOrder", // TODO : Change Accordingly
  },
  {
    text: "Completed",
    path: "/maintenance-order-completed",
    applicationFeatureCode: "MaintenanceOrder", // TODO : Change Accordingly
  },
];

function GetIndexByTabName(tabName) {
  return tabAccessControl(MaintenanceOrderTabs).findIndex((x) => x.text == tabName);
}

export { MaintenanceOrderTabs, GetIndexByTabName };
